import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'
import { User } from '../domain/User'

export class GetUserAfterLogin {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<User> {
    return this.authenticationRepository.getUser()
  }
}
